import React, { useEffect, useImperativeHandle, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { getCurrencyPosition } from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Col, Row } from 'antd';

const messages = defineMessages({
    host: 'Host',
    port: 'Port',
    database: 'Database',
    username: 'Username',
    password: 'Password',
});
const MysqlForm = (props) => {
    const { formId, actions, onSubmit, setIsChangedFormValues, dataDetail, isCreateMode, formRef } = props;

    const { form, mixinFuncs, onValuesChange, setFieldValue, getFieldValue } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    useImperativeHandle(formRef, () => ({
        submit: () => {
            form.submit();
        },
    }));

    const [currencys, setCurrencys] = useState([]);
    const [data, setData] = useState();
    const [formState, setFormState] = useState({});
    const translate = useTranslate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('deviceId');

    useEffect(() => {
        if (dataDetail?.settings) {
            try {
                const parsedSettings = JSON.parse(dataDetail.settings);
                const generalSettings = parsedSettings;
                setFormState(generalSettings);
                form.setFieldsValue({
                    databaseHost: generalSettings?.mysql?.databaseHost,
                    databasePort: generalSettings?.mysql?.databasePort.toString(),
                    database: generalSettings?.mysql?.database,
                    username: generalSettings?.mysql?.username,
                    password: generalSettings?.mysql?.password,
                });
            } catch (error) {
                console.error('Error', error);
            }
        }
    }, [dataDetail, form]);

    const handleSubmitUpdate = (values) => {
        const parsedSettings = JSON.parse(dataDetail.settings);
        const formattedExpireDate = dataDetail?.expireDate ? `${dataDetail.expireDate} 00:00:00` : '';
        const updatedGeneral = {
            ...parsedSettings,
            mysql: {
                ...values,
            },
        };
        const settings = JSON.stringify(updatedGeneral);

        const payload = {
            id: parseInt(deviceId),
            customerId: dataDetail?.customer?.id || 0,
            deviceId: dataDetail?.deviceId,
            expireDate: formattedExpireDate,
            ipSocket: dataDetail?.ipSocket,
            name: dataDetail?.name,
            portSocket: dataDetail?.portSocket,
            settings: settings,
        };

        return onSubmit(payload);
    };

    useEffect(() => {
        if (data) {
            setFormState({ ...data });
            form.setFieldsValue({
                timezone: data?.timezone?.name,
                currency: data?.currency,
                currencyPosition: data?.currency_position,
                decimalSeparator: data?.decimal_separator,
                decimalSpace: data?.decimal_space,
                groupSeparator: data?.group_separator,
                dateTimeFormat: data?.date_time_format,
                group_position: data?.groupPosition,
                priceSetting: data?.price_setting,
            });
        }
    }, [data]);

    const handleFormChange = (changedValues, allValues) => {
        onValuesChange();
        setFormState((prevState) => ({
            ...prevState,
            ...changedValues,
        }));
    };

    useEffect(() => {
        const defaultCurrency = formState.currency || data?.currency || '$';
        const defaultGroupSeparator = formState.groupSeparator || data?.group_separator || '.';
        const defaultDecimalSeparator = formState.decimalSeparator || data?.decimal_separator || ',';
        const decimalSpace = formState.decimalSpace || data?.decimal_space || 2;

        const updatedCurrencys = getCurrencyPosition(
            defaultCurrency,
            defaultGroupSeparator,
            defaultDecimalSeparator,
            decimalSpace,
        );
        setCurrencys(updatedCurrencys);
    }, [formState]);
    return (
        <BaseForm
            id={formId}
            onFinish={handleSubmitUpdate}
            form={form}
            layout="vertical"
            onValuesChange={handleFormChange}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <TextField required label={translate.formatMessage(messages.host)} name="databaseHost" />
                </Col>
                <Col span={12}>
                    <TextField required label={translate.formatMessage(messages.port)} name="databasePort" />
                </Col>
                <Col span={12}>
                    <TextField required label={translate.formatMessage(messages.database)} name="database" />
                </Col>
                <Col span={12}>
                    <TextField required label={translate.formatMessage(messages.username)} name="username" />
                </Col>
                <Col span={12}>
                    <TextField
                        label={translate.formatMessage(messages.password)}
                        required
                        name="password"
                        rules={[
                            {
                                validator: async () => {
                                    const isTouched = form.isFieldTouched('password');
                                    if (isTouched) {
                                        const value = form.getFieldValue('password');
                                        if (value.length < 6) {
                                            throw new Error(translate.formatMessage(commonMessage.validatePassword));
                                        }
                                    }
                                },
                            },
                        ]}
                    />
                </Col>
            </Row>
        </BaseForm>
    );
};

export default MysqlForm;
